import { addTag } from '../onesignal/addTag';
import { concatPath } from '../links/concatPath';
import { healthProfileKey, libraryKey, libraryStackKey, privateKey, healthStackKey as profileStackKey } from '../../constants/routeKeys';
import { logAmplitude } from '../analytics/analytics';
import { router } from 'expo-router';

export enum IntelliProveStage {
  dismiss = 'dismiss',
  faceScanSuccessful = 'faceScanSuccessful',
  dashboardDismiss = 'dashboardDismiss',
  userFinished = 'userFinished',
}

export const intelliproveCallbackOnEvent = (
  stage: string,
  data?: { hasResults?: boolean },
  setHasFaceScanResults?: (value: boolean) => void,
) => {
  console.log('intelliproveCallbackOnEvent', stage, data);

  if (data?.hasResults && setHasFaceScanResults) {
    setHasFaceScanResults(true);
  }

  if (stage === IntelliProveStage.dismiss) {
    console.log('[intelliproveCallbackOnEvent] dismiss stage, hasResults:', data?.hasResults);

    // Navigate to Health tab if face scan has results (successful scan)
    if (data?.hasResults) {
      // Navigate to health dashboard in Health tab after successful face scan
      const path = concatPath([privateKey, profileStackKey, healthProfileKey],-1) as string;
      console.log('[intelliproveCallbackOnEvent] Navigating to health dashboard:', path);
      router.navigate(path);
    } else {
      // Navigate back to library when user cancels
      const path = concatPath([privateKey, libraryStackKey, libraryKey], -1) as string;
      console.log('[intelliproveCallbackOnEvent] Navigating to library:', path);
      router.navigate(path);
    }
  }
  if (stage === IntelliProveStage.userFinished) {
    router.navigate(concatPath([privateKey, libraryStackKey, libraryKey], -1) as string);
  }

  if (stage === IntelliProveStage.dashboardDismiss) {
    router.navigate(concatPath([privateKey, libraryStackKey, libraryKey], -1) as string);
  }

  if(stage === IntelliProveStage.faceScanSuccessful) {
    logAmplitude('Face Scan Finished');
    addTag('last_face_scan', String(Number(new Date())));
  }
};